import { render } from "./IdentityVerification.vue?vue&type=template&id=2b3fd886"
import script from "./IdentityVerification.vue?vue&type=script&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&lang=js"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__